import React from "react";
import MotivosBaseTemplate from "../shared/MotivosBaseTemplate";
import {
  alterarStatusMotivoLocomotivas,
  cadastrarMotivoLocomotivas,
  editarMotivoLocomotivas,
  excluirMotivoLocomotivas,
  listarMotivosLocomotivas,
} from "./motivosLocomotivas.api";

export default function MotivosLocomotivasBase() {
  return (
    <MotivosBaseTemplate
      titulo="Motivos LOCOMOTIVAS"
      descricao="Cadastre os motivos usados pelas interdições de LOCOMOTIVAS do CIM."
      placeholder="Ex.: FREIO DINÂMICO"
      hint="Use esta base para centralizar os motivos de LOCOMOTIVAS no CIM."
      listFn={listarMotivosLocomotivas}
      createFn={cadastrarMotivoLocomotivas}
      updateFn={editarMotivoLocomotivas}
      deleteFn={excluirMotivoLocomotivas}
      toggleFn={alterarStatusMotivoLocomotivas}
    />
  );
}
